import React from 'react'
import { SimpleDashboard } from './components/dashboard/SimpleDashboard'
import AuthenticatedTemplate from './components/auth/AuthenticatedTemplate'
import UnauthenticatedTemplate from './components/auth/UnauthenticatedTemplate'

const embeddedViews = new Map([
  ['/crear-presupuesto', 'create'],
  ['/create-quotation', 'create'],
  ['/quotations/create', 'create'],
  ['/my-quotations', 'list'],
  ['/todos-presupuestos', 'list'],
  ['/all-quotations', 'list'],
  ['/quotations', 'list'],
  ['/quotes', 'list']
])

function App() {
  // Show only UnauthenticatedTemplate on /auth/success path
  const isAuthSuccess = window.location.pathname === '/auth/success';
  const isAuthError = window.location.pathname === '/auth/error';
  const isMyQuotations = window.location.pathname === '/my-quotations'
  const initialView = embeddedViews.get(window.location.pathname)
  const isEmbeddedView = initialView !== undefined

  if (isAuthSuccess || isAuthError) {
    return <UnauthenticatedTemplate />;
  }

  return (
    <>
      <AuthenticatedTemplate>
        <SimpleDashboard
          initialView={initialView}
          embedded={isEmbeddedView}
          hideEmailFilter={isMyQuotations}
        />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate />
    </>
  )
}

export default App
